import { motion } from "framer-motion";
import { WHY } from "@/data/content";
import { SectionHeader } from "@/components/ui-bits";
import { staggerParent, staggerChild } from "@/components/motion-primitives";

export const WhyChooseUs = () => (
  <section id="why" className="relative py-24 md:py-32 bg-background">
    <div className="container mx-auto px-4 md:px-8">
      <SectionHeader
        overline="Municipal Expertise · Professional Management · Less Stress"
        title="Why choose SML Municipal Consulting?"
        subtitle="Dedicated specialists managing your municipal matters from submission to resolution."
      />
      <motion.div
        variants={staggerParent} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
      >
        {WHY.map((w, i) => {
          const Icon = w.icon;
          return (
            <motion.div
              key={i} variants={staggerChild} data-testid={`why-card-${i}`}
              className="group relative rounded-2xl border border-slate-200/80 bg-white p-8 hover:-translate-y-1 hover:shadow-[0_24px_60px_-24px_rgba(15,23,42,0.22)] transition-all duration-400 overflow-hidden"
            >
              <div className="absolute left-0 top-0 h-full w-1 bg-secondary scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-400" />
              <span className="flex items-center justify-center w-14 h-14 rounded-2xl bg-primary text-white group-hover:bg-secondary transition-colors">
                <Icon className="w-6 h-6" />
              </span>
              <h3 className="mt-6 font-heading text-lg font-semibold text-primary leading-snug">{w.title}</h3>
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{w.text}</p>
            </motion.div>
          );
        })}
      </motion.div>
    </div>
  </section>
);
